(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ventahoyrealtime', Ventahoyrealtime);

    Ventahoyrealtime.$inject = ['$resource', 'DateUtils'];

    function Ventahoyrealtime ($resource, DateUtils) {
        var resourceUrl =  'api/ventahoyrealtimes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        //data.fechaproceso = DateUtils.convertDateTimeFromServer(data.fechaproceso);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
